module.exports = __webpack_public_path__ + "img/79686278_605056223579705_187902333288567605_n.207bea15.jpg";